// Question saisie dans la démo IA de l'accueil, en attente d'être envoyée après inscription/connexion.
// TTL 60 min pour éviter qu'une question oubliée ne soit renvoyée plus tard pour un autre utilisateur.
const KEY = "proxi_pending_ai_question";
const TTL_MS = 60 * 60 * 1000;

export function hasPendingAiQuestion() {
  try {
    const { q, ts } = JSON.parse(localStorage.getItem(KEY) || "null") || {};
    return !!q && !!ts && Date.now() - ts < TTL_MS;
  } catch {
    return false;
  }
}
